exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CreateUpdateTagModal-defaultContent-24t5e form{margin:0}.CreateUpdateTagModal-actionGroup-3EGF6 button{margin-bottom:15px}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb{margin:0;padding:0;list-style-type:none}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li{display:inline-block;width:25%;text-align:center;vertical-align:top}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button{padding:0;font-size:14px;font-weight:400;white-space:normal;color:#8a959a}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button.active{color:#546d79}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button:hover{text-decoration:none}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button:hover label,.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button:hover small{color:#546d79}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button label{display:block;margin:0;min-height:40px}.CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb>li button label:first-letter{text-transform:uppercase}", ""]);

// exports
exports.locals = {
	"defaultContent": "CreateUpdateTagModal-defaultContent-24t5e",
	"actionGroup": "CreateUpdateTagModal-actionGroup-3EGF6",
	"typeaheadHeaderGroup": "CreateUpdateTagModal-typeaheadHeaderGroup-2Y-lb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/reference/components/CreateUpdateTagModal.less
// module id = 1736
// module chunks = 0